export const GET_ALL_REFERAL = 'referal/all'
export const CREATE_REFERAL = 'referal/create'
export const DETAIL_REFERAL = 'referal/detail'
export const INVITED_USERS_REFERAL = 'referal/invited_users'
export const EARNINGS_REFERAL = 'referal/earnings'
export const PAYOUT_REFERRAL = 'referal/payout'
